import {
    Add,
    Remove,
    ArrowLeftOutlined,
    ArrowRightOutlined,
} from "@material-ui/icons";
import styled from "styled-components";
import Announcement from "../components/Announcement";
import Footer from "../components/Footer";
import Newsletter from "../components/Newsletter";
import { mobile, tablet } from "../responsive";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { publicRequest } from "../requestMethods";
import { addProduct, addQuantity } from "../redux/cartRedux";
import { useDispatch, useSelector } from "react-redux";
import { useIntl, FormattedMessage } from "react-intl";
import { products as localProducts, serviceProducts } from "../data";

const Container = styled.div`
    font-size: 1.2rem;
    line-height: 2.5rem;
    ${mobile({
        fontSize: "1rem",
    })}
    ${tablet({
        fontSize: "1rem",
    })}
`;

const Wrapper = styled.div`
    padding: 40px 50px;
    display: flex;
    gap: 40px;
    ${mobile({ padding: "20px 10px", flexDirection: "column", gap: "20px" })}
    ${tablet({ padding: "30px 10px", flexDirection: "column", gap: "30px" })}
`;

const ImgContainer = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #f5f5f5 0%, #ffffff 100%);
    border-radius: 16px;
    padding: 20px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    ${mobile({ order: "1" })}
    ${tablet({ order: "1" })}
`;

const Image = styled.img`
    width: 100%;
    height: 60vh;
    object-fit: contain;
    cursor: pointer;
    ${mobile({ height: "30vh", margin: "0" })}
    ${tablet({ height: "50vh", margin: "0" })}
`;

const FullImage = styled.img`
    width: 75vh;
    height: 100vh;
    object-fit: contain;
    cursor: pointer;
    background: white;
    ${mobile({ height: "30vh", margin: "0" })}
    ${tablet({ height: "30vh", margin: "0" })}
`;

const GalleryFullImage = styled.img`
    width: 100vh;
    height: 100vh;
    object-fit: contain;
    cursor: pointer;
    ${mobile({ height: "30vh", margin: "0" })}
    ${tablet({ height: "30vh", margin: "0" })}
`;

const InfoContainer = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    ${mobile({ padding: "0rem 10px", order: "3" })}
    ${tablet({ padding: "0rem 10px", order: "3" })}
`;

const Title = styled.h1`
    font-family: Jost-Bold;
    margin-bottom: 0.5rem;
    font-size: 2.5rem;
    font-weight: 800;
    padding-bottom: 10px;
    overflow-wrap: anywhere;
    color: var(--wellness-primary);
    line-height: 1.2;
    ${mobile({ fontSize: "1.8rem", margin: "0" })}
    ${tablet({ fontSize: "2rem", margin: "0" })}
`;


const Subtitle = styled.p`
    font-family: Jost-SemiBold;
    font-size: 1.6rem;
    color: var(--wellness-secondary);
    margin-bottom: 1.5rem;
    ${mobile({ padding: "0", lineHeight: "1.8rem", fontSize: "1.2rem" })}
    ${tablet({ padding: "0", lineHeight: "1.8rem", fontSize: "1.2rem" })}
`;

const Desc = styled.p`
    font-family: Jost-SemiBold;
    font-weight: 400;
    ${mobile({ padding: "0", lineHeight: "2.5rem", fontSize: "1rem" })}
    ${tablet({ padding: "0", lineHeight: "2.5rem", fontSize: "1rem" })}
`;

const FeaturesContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 1.2rem;
    margin-top: 2rem;
    ${mobile({ gridTemplateColumns: "1fr", gap: "1rem" })}
    ${tablet({ gridTemplateColumns: "1fr", gap: "1rem" })}
`;

const FeatureCard = styled.div`
    background: linear-gradient(135deg, #f5f5f5 0%, #ffffff 100%);
    border: 1px solid #e0e0e0;
    border-radius: 12px;
    padding: 1.5rem;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    
    &:hover {
        transform: translateY(-4px);
        box-shadow: 0 6px 20px rgba(55, 72, 54, 0.15);
        border-color: var(--wellness-primary);
    }
`;

const FeatureNumber = styled.div`
    width: 40px;
    height: 40px;
    background: linear-gradient(135deg, var(--wellness-primary) 0%, var(--wellness-secondary) 100%);
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Jost-Bold;
    font-size: 1.2rem;
    margin-bottom: 1rem;
    box-shadow: 0 4px 12px rgba(55, 72, 54, 0.2);
`;

const FeatureTitle = styled.h3`
    font-family: Jost-Bold;
    font-size: 1.1rem;
    margin: 0 0 0.5rem 0;
    color: var(--wellness-primary);
`;

const FeatureDesc = styled.p`
    font-family: Jost-Light;
    font-size: 0.95rem;
    color: #666;
    margin: 0;
    line-height: 1.6;
`;

const WatchContainer = styled.div`
    margin-top: 30px;
    margin-bottom: 30px;
    ${mobile({ marginBottom: "0" })}
    ${tablet({ marginBottom: "0" })}
`;

const Price = styled.div`
    font-family: Jost-Bold;
    font-size: 2rem;
    color: var(--wellness-primary);
    ${mobile({ fontSize: "1.5rem" })}
    ${tablet({ fontSize: "1.5rem" })}
`;

const PriceContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 2rem;
    ${mobile({ flexDirection: "column", alignItems: "flex-start", gap: "1.5rem" })}
    ${tablet({ flexDirection: "column", alignItems: "flex-start", gap: "1.5rem" })}
`;

const AddContainer = styled.div`
    width: 80%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1.5rem;
    background: linear-gradient(135deg, #f9f9f9 0%, #ffffff 100%);
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
    margin-top: 2rem;
    ${mobile({ width: "100%", margin: "1rem 0", flexDirection: "column", gap: "1rem", alignItems: "flex-start" })}
    ${tablet({ width: "100%", margin: "1rem 0", flexDirection: "column", gap: "1rem", alignItems: "flex-start" })}
`;

const AmountContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 1rem;
    font-weight: 700;
    font-size: 1.2rem;
`;

const Amount = styled.span`
    min-width: 50px;
    height: 50px;
    border-radius: 8px;
    border: 2px solid var(--wellness-primary);
    display: flex;
    align-items: center;
    justify-content: center;
    background: white;
    color: var(--wellness-primary);
`;

const AddRemoveButton = styled.div`
    width: 50px;
    height: 50px;
    border-radius: 8px;
    border: 2px solid var(--wellness-primary);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: white;
    color: var(--wellness-primary);
    transition: all 0.3s ease;
    
    &:hover {
        background: var(--wellness-primary);
        color: white;
        transform: scale(1.1);
    }
`;

const Button = styled.button`
    width: 100%;
    margin: 25px 0;
    padding: 16px 32px;
    border: none;
    background: linear-gradient(135deg, var(--wellness-primary) 0%, var(--wellness-secondary) 100%);
    color: white;
    cursor: pointer;
    font-family: Jost-Bold;
    font-size: 1.1rem;
    border-radius: 8px;
    transition: all 0.3s ease;
    box-shadow: 0 4px 12px rgba(55, 72, 54, 0.3);

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(55, 72, 54, 0.4);
    }
    
    &:active {
        transform: translateY(0);
    }
    
    ${mobile({ width: "100%", margin: "1rem 0", fontSize: "1rem", padding: "14px 24px" })}
    ${tablet({ width: "100%", margin: "1rem 0", fontSize: "1rem", padding: "14px 24px" })}
`;

const ImageModalContainer = styled.div`
    height: 100%;
    width: 100%;
    background: black;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    position: fixed;
    z-index: 100;
`;


const ImageOverlay = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    color: white;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    top: 0;
    background-color: white;
    visibility: visible;
`;

const ModalDetails = styled.div`
    background-color: rgba(white, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    height: 100%;
    width: 33.33%;
    display: flex;
    z-index: 102;
    ${mobile({ width: "100%", height: "100%" })}
    ${tablet({ width: "100%", height: "100%" })}
`;


const Close = styled.div`
    font-size: 1.5rem;
    cursor: pointer;
    position: absolute;
    top: 1rem;
    right: 2rem;
`;


const Arrow = styled.div`
    width: 50px;
    height: 50px;
    background-color: #fff7f7;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    bottom: 0;
    left: ${(props) => props.direction === "left" && "10px"};
    right: ${(props) => props.direction === "right" && "10px"};
    margin: auto;
    cursor: pointer;
    opacity: 0.5;
    z-index: 9999;
`;

const GalleryModalContainer = styled.div`
    height: 100%;
    width: 100%;
    background: black;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    position: fixed;
    z-index: 100;
`;

const Product = () => {
    const location = useLocation();
    const id = location.pathname.split("/")[2];
    const [imageModal, setImageModal] = useState(false);
    const [galleryModal, setGalleryModal] = useState(false);
    const [product, setProduct] = useState({});
    const [quantity, setQuantity] = useState(1);
    //eslint-disable-next-line
    const [colorpicker, setColorPicker] = useState(false);
    const [activeColor, setActiveColor] = useState({});
    const dispatch = useDispatch();
     const intl = useIntl()

    const admin = useSelector((state) => state.cart.products);

    // Helper function to parse features from description
    const parseFeatures = (description) => {
        if (!description) return [];
        const lines = description.split('\n').filter(line => line.trim());
        return lines
            .map(line => {
                const match = line.match(/^(\d+)\.\s*(.+?):\s*(.+)$/);
                if (match) {
                    return {
                        number: parseInt(match[1]),
                        title: match[2],
                        description: match[3]
                    };
                }
                return null;
            })
            .filter(feature => feature !== null);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        const getProduct = async () => {
            try {
                const res = await publicRequest.get("/products/find/" + id);
                if (res.data && res.data._id) {
                    setProduct(res.data);
                    setActiveColor({ color: res.data.color[0], i: 0 });
                } else {
                    // Fallback to local data
                    const allLocalProducts = [...localProducts, ...serviceProducts];
                    const localProduct = allLocalProducts.find(p => p._id === id || p.model === id);
                    if (localProduct) {
                        setProduct(localProduct);
                        setActiveColor({ color: localProduct.color[0], i: 0 });
                    }
                }
            } catch (err) {
                // If API fails, use local data
                const allLocalProducts = [...localProducts, ...serviceProducts];
                const localProduct = allLocalProducts.find(p => p._id === id || p.model === id);
                if (localProduct) {
                    setProduct(localProduct);
                    setActiveColor({ color: localProduct.color[0], i: 0 });
                }
            }
        };
        getProduct();
    }, [id]);

    useEffect(() => {
        window.scrollTo(0, 0);
        if (colorpicker === true) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [colorpicker]);

    useEffect(() => {
        window.scrollTo(0, 0);
        if (imageModal === true) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [imageModal]);

    useEffect(() => {
        window.scrollTo(0, 0);
        if (galleryModal === false) {
            document.body.style.overflow = "inherit";
        } else {
            document.body.style.overflow = "hidden";
        }
    }, [galleryModal]);

    const handleQuantity = (type) => {
        if (type === "dec") {
            quantity > 1 && setQuantity(quantity - 1);
        } else {
            setQuantity(quantity + 1);
        }
    };

    const handleClick = () => {
        try {
            if (
                admin.find(
                    (item) =>
                        `${item.model}-${item.color.name}` ===
                        `${product?.model}-${activeColor.name}`
                ) === undefined
            ) {
                dispatch(addProduct({ ...product, activeColor, quantity }));
            } else {
                dispatch(addQuantity({ ...product, activeColor, quantity }));
            }
            alert("Product added to cart");
            window.scrollTo(0, 0);
            window.location.href = "/cart";
        } catch {}
    };

    const handleGallerySwipe = (direction) => {
        const totalGallery = product?.gallery.length;
        if (direction === "right") {
            const newIndex =
                galleryModal.i + 1 < totalGallery ? galleryModal.i + 1 : 0;
            setGalleryModal({
                gallery: product?.gallery[newIndex],
                i: newIndex,
            });
        } else {
            const newIndex =
                galleryModal.i - 1 < 0 ? totalGallery - 1 : galleryModal.i - 1;
            setGalleryModal({
                gallery: product?.gallery[newIndex],
                i: newIndex,
            });
        }
    };

    const handleImageSwipe = (direction) => {
        const totalColor = product?.color.length;
        if (direction === "right") {
            const newIndex =
                activeColor.i + 1 < totalColor ? activeColor.i + 1 : 0;
            setActiveColor({
                color: product?.color[newIndex],
                i: newIndex,
            });
        } else {
            const newIndex =
                activeColor.i - 1 < 0 ? totalColor - 1 : activeColor.i - 1;
            setActiveColor({
                color: product?.color[newIndex],
                i: newIndex,
            });
        }
    };
    return (
        <Container>
            <Announcement />
            <>
                {" "}
                <Wrapper>
                    <ImgContainer>
                        <Image
                            onClick={() => {
                                window.innerWidth > 480
                                    ? setImageModal(true)
                                    : setImageModal(false);
                            }}
                            src={
                                activeColor.color
                                    ? activeColor.color.img
                                        ? activeColor.color.img
                                        : ""
                                    : ""
                            }
                        />
                    </ImgContainer>
                    <InfoContainer>
                        <WatchContainer>
                        {product?.title === "G10" ? (
    <>
        <Title><FormattedMessage id="product_title_1" defaultMessage="" /></Title>
        <Title><FormattedMessage id="product_title_2" defaultMessage="" />!</Title>
    </>
) : (
    <Title>{intl.locale === "es" ? product?.cnTitle : product?.title}</Title>
)}

                            <Subtitle><FormattedMessage id="product_subtitle_1" defaultMessage="" /> </Subtitle>
                            
                            {/* Render features as cards for G10, or description for other products */}
                            {product?.title === "G10" ? (
                                <FeaturesContainer>
                                    {parseFeatures(intl.locale === "es" ? product?.cnDescription : product?.description).map((feature, index) => (
                                        <FeatureCard key={index}>
                                            <FeatureNumber>{feature.number}</FeatureNumber>
                                            <FeatureTitle>{feature.title}</FeatureTitle>
                                            <FeatureDesc>{feature.description}</FeatureDesc>
                                        </FeatureCard>
                                    ))}
                                </FeaturesContainer>
                            ) : (
                                <>
                                    <Desc dangerouslySetInnerHTML={{ __html: intl.locale === "es" ? `${product?.cnDescription ? product?.cnDescription.replace(/\n/g, "<br>") : ""}` : `${product?.description ? product?.description.replace(/\n/g, "<br>"): ""}` }} />
                                    <Desc>
                                        {" "}
                                        {product?.powerReserve
                                            ? `Power Reserve : ${product?.powerReserve}`
                                            : ""}
                                    </Desc>
                                    <Desc>
                                        {" "}
                                        {product?.vibrationFrequency
                                            ? `Vibration Frequency : ${product?.vibrationFrequency}`
                                            : ""}
                                    </Desc>
                                    <Desc>
                                        {" "}
                                        {product?.drive
                                            ? `Drive : ${product?.drive}`
                                            : ""}
                                    </Desc>
                                    <Desc>
                                        {" "}
                                        {product?.windingMethod
                                            ? `Winding Method : ${product?.windingMethod}`
                                            : ""}
                                    </Desc>
                                    <Desc>
                                        {" "}
                                        {product?.caseDiameter
                                            ? `Case Diameter : ${product?.caseDiameter}`
                                            : ""}
                                    </Desc>
                                    <Desc>
                                        {" "}
                                        {product?.caseMaterial
                                            ? `Case Material : ${product?.caseMaterial}`
                                            : ""}
                                    </Desc>
                                    <Desc>
                                        {" "}
                                        {product?.waterResistance
                                            ? `Water Resistance : ${product?.waterResistance}`
                                            : ""}
                                    </Desc>
                                    <Desc>
                                        {" "}
                                        {product?.mirror
                                            ? `Mirror : ${product?.mirror}`
                                            : ""}
                                    </Desc>
                                    <Desc>
                                        {" "}
                                        {product?.strapMaterial
                                            ? `Strap Material : ${product?.strapMaterial}`
                                            : ""}
                                    </Desc>
                                </>
                            )}
                        </WatchContainer>
                        <PriceContainer>
                            {product?.label === "soldout" ? null : (
                                <Price>
                                    RM {(product?.price)}.00
                                </Price>
                            )}
                            <AmountContainer>
                                <AddRemoveButton onClick={() => handleQuantity("dec")}>
                                    <Remove />
                                </AddRemoveButton>
                                <Amount>{quantity}</Amount>
                                <AddRemoveButton onClick={() => handleQuantity("inc")}>
                                    <Add />
                                </AddRemoveButton>
                            </AmountContainer>
                        </PriceContainer>
                        
                        {
                            product?.label === "soldout" ? <Button>LIMITED</Button> : <Button onClick={handleClick}><FormattedMessage id="product_button" defaultMessage="" /></Button>
                        }
                    </InfoContainer>
                </Wrapper>
            </>
            {imageModal && (
                <>
                    <Arrow
                        direction="left"
                        onClick={() => handleImageSwipe("left")}
                    >
                        <ArrowLeftOutlined />
                    </Arrow>
                    <ImageModalContainer
                        onClick={() => setImageModal(false)}
                    ></ImageModalContainer>
                    <ImageOverlay>
                        <ModalDetails>
                            <Close onClick={() => setImageModal(false)}>
                                X
                            </Close>
                            <FullImage
                                onClick={() => setImageModal(true)}
                                src={
                                    activeColor.color.img
                                        ? activeColor.color.img
                                        : ""
                                }
                            />
                        </ModalDetails>
                    </ImageOverlay>
                    <Arrow
                        direction="right"
                        onClick={() => handleImageSwipe("right")}
                    >
                        <ArrowRightOutlined />
                    </Arrow>
                </>
            )}

            {galleryModal && (
                <>
                    <Arrow
                        direction="left"
                        onClick={() => handleGallerySwipe("left")}
                    >
                        <ArrowLeftOutlined />
                    </Arrow>
                    <GalleryModalContainer
                        onClick={() => setGalleryModal(false)}
                    ></GalleryModalContainer>
                    <ImageOverlay>
                        <ModalDetails>
                            <Close onClick={() => setGalleryModal(false)}>
                                X
                            </Close>
                            <GalleryFullImage
                                onClick={() => setGalleryModal(galleryModal)}
                                src={
                                    galleryModal
                                        ? product?.gallery[galleryModal.i].img
                                        : ""
                                }
                            />
                        </ModalDetails>
                    </ImageOverlay>
                    <Arrow
                        direction="right"
                        onClick={() => handleGallerySwipe("right")}
                    >
                        <ArrowRightOutlined />
                    </Arrow>
                </>
            )}
            <Newsletter />
            <Footer />
        </Container>
    );
};

export default Product;
